// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1akt8","inputWrap":"CustomTip_inputWrap__N2Pli"};